/* istanbul ignore file */
export const getWindow = () => window;

export const getNavigator = () => navigator;
